import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { colorTokenFromNestedArguments, sizeConst, sizeTokenFromNestedArguments, referenceForwardArgs } from '@klarna/designtokens';
import defaultColorVariables from '@bubble-ui/particle-default-color-variables';
import defaultCornerRadii from '@bubble-ui/particle-default-corner-radii';
import defaultSpaceTokens from '@bubble-ui/particle-default-space-tokens';
import defaultTextStyles from '@bubble-ui/particle-default-text-styles';
var bulletBackgroundColor = {
  error: tokenResolver => tokenResolver('colors/backgrounds/error-floating'),
  warning: tokenResolver => tokenResolver('colors/backgrounds/warning-floating'),
  disabled: tokenResolver => tokenResolver('colors/backgrounds/neutral', {
    interactiveState: 'disabled'
  }),
  future: tokenResolver => tokenResolver('colors/backgrounds/neutral'),
  default: tokenResolver => tokenResolver('colors/backgrounds/inverse')
};
var bulletContentColor = {
  error: tokenResolver => tokenResolver('colors/text/error'),
  warning: tokenResolver => tokenResolver('colors/text/warning'),
  default: tokenResolver => tokenResolver('colors/text/inverse')
};
var descriptionTextColor = {
  disabled: tokenResolver => tokenResolver('colors/text/default', {
    interactiveState: 'disabled'
  }),
  default: tokenResolver => tokenResolver('colors/text/default')
};
var lineColor = {
  done: tokenResolver => tokenResolver('colors/backgrounds/inverse'),
  disabled: tokenResolver => tokenResolver('colors/backgrounds/neutral', {
    interactiveState: 'disabled'
  }),
  default: tokenResolver => tokenResolver('colors/backgrounds/neutral')
};
var titleTextColor = {
  disabled: tokenResolver => tokenResolver('colors/text/default', {
    interactiveState: 'disabled'
  }),
  default: tokenResolver => tokenResolver('colors/text/default')
};
var bulletSize = {
  big: 24,
  default: 12
};
var lineCornerRadius = {
  dashed: tokenResolver => tokenResolver('corner-radius/none'),
  default: tokenResolver => tokenResolver('corner-radius/round')
};
export var defaultDesignTokens = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, defaultColorVariables), defaultCornerRadii), defaultSpaceTokens), defaultTextStyles), {}, {
  // Colors
  'stepper/bullet-background-color': colorTokenFromNestedArguments(bulletBackgroundColor, ['state']),
  'stepper/bullet-content-color': colorTokenFromNestedArguments(bulletContentColor, ['state']),
  'stepper/bullet-loader-color': referenceForwardArgs('colors/borders/default'),
  'stepper/description-text-color': colorTokenFromNestedArguments(descriptionTextColor, ['state']),
  'stepper/line-color': colorTokenFromNestedArguments(lineColor, ['lineState']),
  'stepper/title-text-color': colorTokenFromNestedArguments(titleTextColor, ['state']),
  // Sizes
  'stepper/bullet-corner-radius': referenceForwardArgs('corner-radius/round'),
  'stepper/bullet-size': sizeTokenFromNestedArguments(bulletSize, ['bulletSize']),
  'stepper/line-corner-radius': sizeTokenFromNestedArguments(lineCornerRadius, ['lineStyle']),
  'stepper/line-width': sizeConst(2),
  // Text styles
  'stepper/bullet-content-text-style': referenceForwardArgs('text-style/text/paragraphs/default/medium'),
  'stepper/description-text-style': referenceForwardArgs('text-style/text/super-paragraphs/default/regular'),
  'stepper/title-text-style': referenceForwardArgs('text-style/text/super-paragraphs/body/medium')
});
//# sourceMappingURL=defaultDesignTokens.js.map